import { Navigate } from 'react-router-dom';

export function LeadSources() {
  return <Navigate to="/reports" replace />;
}
